"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wordBreaks = new Set(['normal', 'break-all', 'keep-all', 'break-word']);
exports.default = (function (_a) {
    var wordBreak = _a.wordBreak;
    return wordBreaks.has(wordBreak) && "word-break: " + wordBreak + ";";
});
